export const successMessage = {
  createOrder: 'Order Request Created Successfully',
  updateOrder: 'Order Request Updated Successfully',
  deleteOrder: 'Order Request Deleted Successfully',
  addNote: 'Note added Successfully',
};
